/**
 * ============================================================================
 * Outsource 模块 - 枚举定义
 * ============================================================================
 *
 * @description 委外管理模块枚举类型
 * @backend-mapping backend/app/Modules/Outsource/Models/OutsourceOrder.php
 * @last-updated 2026-03-13
 * ============================================================================
 */

/**
 * 委外订单状态枚举
 * 对应后端: OutsourceOrder::STATUS_*
 */
export enum OutsourceOrderStatus {
  /** 草稿 */
  DRAFT = 1,
  /** 待审核 */
  PENDING = 2,
  /** 已确认 */
  CONFIRMED = 3,
  /** 已发料 */
  SHIPPED = 4,
  /** 加工中 */
  PROCESSING = 5,
  /** 部分收货 */
  PARTIAL_RECEIVED = 6,
  /** 全部收货 */
  RECEIVED = 7,
  /** 已结算 */
  SETTLED = 8,
  /** 已关闭 */
  CLOSED = 9,
  /** 已取消 */
  CANCELLED = 10,
}

/**
 * 委外订单优先级枚举
 * 对应后端: OutsourceOrder::PRIORITY_*
 */
export enum OutsourcePriority {
  /** 紧急 */
  URGENT = 1,
  /** 高 */
  HIGH = 2,
  /** 中 */
  MEDIUM = 3,
  /** 低 */
  LOW = 4,
}

/**
 * 委外收货质检状态枚举
 * 对应后端: OutsourceReceiving::QUALITY_*
 */
export enum OutsourceQualityStatus {
  /** 待检 */
  PENDING = 1,
  /** 合格 */
  QUALIFIED = 2,
  /** 不合格 */
  REJECTED = 3,
}

/**
 * 委外异常处理状态
 * 对应后端: OutsourceReceiving::EXCEPTION_*
 */
export enum OutsourceExceptionStatus {
  /** 无异常 */
  NONE = 0,
  /** 待处理 */
  PENDING = 1,
  /** 处理中 */
  PROCESSING = 2,
  /** 已关闭 */
  CLOSED = 3,
}

/**
 * 委外异常处理动作
 * 对应后端: OutsourceReceiving::ACTION_*
 */
export enum OutsourceExceptionAction {
  /** 关闭 */
  CLOSE = 'close',
  /** 返工 */
  REWORK = 'rework',
  /** 补料 */
  SUPPLEMENT = 'supplement',
}

/**
 * 委外退料类型枚举
 * 对应后端: OutsourceReturn::RETURN_TYPE_*
 */
export enum OutsourceReturnType {
  /** 多余退料 */
  EXCESS = 1,
  /** 质量问题退料 */
  QUALITY = 2,
}
